export function forceInputUppercase(inputElement) {
  const start = inputElement.target.selectionStart;
  const end = inputElement.target.selectionEnd;
  inputElement.target.value = inputElement.target.value.toUpperCase();
  inputElement.target.setSelectionRange(start, end);
}
